export default "__VITE_ASSET__BDJcqS1k__"